import React from 'react'
import { observer, inject } from 'mobx-react'

import { ITEM_TYPE_SURVEY } from '@client/components/Editor/settings'

import './styles.scss'

function getMessage(editor, app) {
  const surveyQuestionsMissing = editor.kind === ITEM_TYPE_SURVEY && !editor.hasFieldBlocks

  if (!surveyQuestionsMissing) {
    return ''
  }

  if (surveyQuestionsMissing) {
    return app.formatMessage('requiredBlocks.surveyQuestionsMissing')
  }
}

export const RequiredBlocksWarning = ({ app, editor }) => {
  const message = getMessage(editor, app)

  if (editor.kind !== ITEM_TYPE_SURVEY) {
    return null
  }

  return (
    <div className={`required-blocks-warning${message ? ' show' : ''}`}>
      <span className="required-blocks-warning--message">{message}</span>
    </div>
  )
}

export default inject('app', 'editor')(observer(RequiredBlocksWarning))
